'use client'

import { useEffect, useState } from 'react'

interface SecureEmailProps {
  user: string
  domain: string
  className?: string
  showAsButton?: boolean
  buttonText?: string
}

/**
 * SecureEmail component that obfuscates email addresses from spam bots.
 * The email is only constructed client-side via JavaScript.
 */
export function SecureEmail({
  user,
  domain,
  className = '',
  showAsButton = false,
  buttonText,
}: SecureEmailProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Server-side: render placeholder
  if (!mounted) {
    return showAsButton ? (
      <span className={className}>{buttonText || 'Email'}</span>
    ) : (
      <span className={className}>[Email Protected]</span>
    )
  }

  // Client-side: construct email
  const email = `${user}@${domain}`
  const href = `mailto:${email}`

  if (showAsButton) {
    return (
      <a href={href} className={className}>
        {buttonText || email}
      </a>
    )
  }

  return (
    <a href={href} className={className}>
      {email}
    </a>
  )
}
